type ExternalLinkWithTypeClickEvent = {
  detail: [{ data: string; type: "phone" | "email" | "website" }];
};

type ExternalLinkClickEvent = {
  detail: [string];
};

function openExternalLink(url: string) {
  if (url.startsWith("http://") || url.startsWith("https://")) {
    window.open(url, "_blank");
  } else {
    window.open(`https://${url}`, "_blank");
  }
}

export function externalLinkWithTypeClickHandler(
  event: ExternalLinkWithTypeClickEvent,
) {
  if (event.detail[0].type === "phone") {
    window.location.href = `tel:${event.detail[0].data}`;
  } else if (event.detail[0].type === "email") {
    window.location.href = `mailto:${event.detail[0].data}`;
  } else if (event.detail[0].type === "website") {
    const urlString = event.detail[0].data;
    openExternalLink(urlString);
    return;
  }
}

export function externalLinkClickHandler(event: ExternalLinkClickEvent) {
  const urlString = event.detail[0];
  openExternalLink(urlString);
}
